import React from "react";
//import { AlertCircle, ArrowRight } from "lucide-react";
import { ReactComponent as InfoCircle } from "assets/img/svg/InfoCircle.svg";
import { ReactComponent as RightArrow } from "assets/img/svg/RightArrow.svg";
const CorrectionBox = ({ message, onEdit, actionNeededText='' }) => (
  <div className="correction-box">
    <div>
    <div className="correction-icon">
      {<InfoCircle/> }
    </div>
    <div className="correction-body">
      <div className="correction-title">Correction needed</div>
      <div className="correction-message">{message}</div>
      <button className="correction-button" onClick={onEdit}>
        <span style={{fontWeight:'600'}}>{actionNeededText}</span> <RightArrow size={16} />
      </button>
    </div>
    </div>
  </div>
);

export default CorrectionBox;
